import { reverse } from "@reactivated";

import {
    IAddress,
    IAddressCountry,
    IAddressState,
} from "../models/address.interfaces";
import { ajax } from "../utils/ajax";
import { PromiseMutex } from "../utils/mutex";

/**
 * List countries.
 */
export const loadCountries = async (): Promise<IAddressCountry[]> => {
    const mutex = new PromiseMutex<IAddressCountry[]>(
        "address-load-countries",
        true,
    );
    let loading = mutex.getPromise();
    if (!loading) {
        loading = ajax
            .get(reverse("country-list"))
            .set("Accept", "application/json")
            .then((resp) => {
                return resp.body;
            });
        mutex.setPromise(loading);
    }
    return loading;
};

/**
 * List states for the given country code
 */
export const loadStates = async (
    countryCode: string,
): Promise<IAddressState[]> => {
    if (!countryCode) {
        // TODO(i18n): Wrap user-facing error message in t tagged template: t`Cannot list shipping methods without a destination state`
        throw new Error(
            "Cannot list shipping methods without a destination state",
        );
    }

    const mutex = new PromiseMutex<IAddressState[]>(
        `address-load-${countryCode}-states`,
    );
    let loading = mutex.getPromise();
    if (!loading) {
        loading = ajax
            .get(reverse("country-state-list", { country_code: countryCode }))
            .set("Accept", "application/json")
            .then((resp) => {
                return resp.body;
            });
        mutex.setPromise(loading);
    }
    return loading;
};

/**
 * List addresses saved for the user
 */
export const listUserAddresses = async (): Promise<IAddress[]> => {
    const mutex = new PromiseMutex<IAddress[]>("load-user-addresses");
    let loading = mutex.getPromise();
    if (!loading) {
        loading = ajax
            .get(reverse("useraddress-list"))
            .set("Accept", "application/json")
            .then((resp): IAddress[] => {
                return resp.body;
            });
        mutex.setPromise(loading);
    }
    return loading;
};
